import { render, staticRenderFns } from "./OrderableItem.vue?vue&type=template&id=43dda47e"
import script from "./OrderableItem.vue?vue&type=script&lang=js"
export * from "./OrderableItem.vue?vue&type=script&lang=js"
import style0 from "./OrderableItem.vue?vue&type=style&index=0&id=43dda47e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports